import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom"; // If using React Router

const JoinOurteam = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    async function fetchReasonsData() {
      try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/careers`);
        //console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setBanner(events.banner);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
    }
    fetchReasonsData();
  }, []);

  if (!banner) return null;

  return (
    <div className="relative w-full overflow-hidden">
      <img
        // src={`${process.env.REACT_APP_COURSE_API_BASEURL}${banner.image}`}
        src={banner.image}
        alt="Banner"
        className="w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover"
      />
      {/* Text container with black opacity */}
      <div className="!absolute inset-0 flex w-full items-center justify-center">
        <div className="bg-black bg-opacity-50 text-white w-full text-center p-6 rounded-lg">
          <h1 className="text-7xl md:text-7xl font-bold">{banner.title}</h1>
          <Link
            to={banner.buttonLink}
            className="mt-4 inline-block bg-yellow-500 text-black px-6 py-2 rounded-lg font-semibold hover:bg-yellow-600 transition"
          >
            {banner.buttonText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JoinOurteam;
